var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:[
    _vm.$style.progressStep,
    { [_vm.$style.isActive]: _vm.active },
    { [_vm.$style.isValid]: _vm.valid },
    { [_vm.$style.firstItem]: _vm.firstItem },
  ],on:{"click":_vm.stepClicked}},[_c('a',{class:_vm.$style.progressLink,attrs:{"href":"javascript:"}},[_c('div',{class:_vm.$style.progressContainer},[(_vm.firstItem === false)?_c('div',{class:_vm.$style.progressPath},[_c('span',{class:_vm.$style.progressPathDefault}),_c('span',{class:[
            _vm.$style.progressPathIsactive,
            { [_vm.$style.isActive]: _vm.active },
            { [_vm.$style.isValid]: _vm.valid },
          ]})]):_vm._e(),_c('div',{class:[
          _vm.$style.progressMarker,
          { [_vm.$style.isActive]: _vm.active },
          { [_vm.$style.isValid]: _vm.valid },
        ]},[(_vm.active)?_c('span',{class:_vm.$style.progressMarkerContent},[_vm._v(_vm._s(_vm.index))]):(_vm.valid)?_c('icon',{class:[_vm.$style.progressMarkerContentSmall],attrs:{"icon":"check"}}):_vm._e()],1)]),_c('div',{class:[_vm.$style.progressText, { [_vm.$style.isActive]: _vm.active }, { [_vm.$style.isComplete]: _vm.complete }]},[_c('p',[_vm._v(_vm._s(_vm.label))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }